import { TVisibleForm, TTypeOfModalWindow } from './createSubCategoryContext';
import {
	TFileId,
	ICreateSubCategoryValidationError,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	IServerError,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateSubCategory,
} from 'types';

export enum CreateSubCategoryActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_SUBCATEGORY = 'CHANGE_NAME_OF_SUBCATEGORY',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE = 'SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE',
	SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION = 'SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateSubCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFileId {
	type: CreateSubCategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface ISetFetchedCustomers {
	type: CreateSubCategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetIDCustomer {
	type: CreateSubCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: CreateSubCategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfoWithStatus[];
	};
}

interface ISetIDsRestaurant {
	type: CreateSubCategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: string[];
		IDsOfRestaurantsWhereToHide: string[];
		IDsOfRestaurantsAvailableForRepetition: string[];
	};
}

interface IChangeNameOfSubCategory {
	type: CreateSubCategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY;
	payload: {
		nameOfSubCategory: string;
	};
}

interface ISetFetchedCategories {
	type: CreateSubCategoryActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		categories: IItemForGetShortInfo[];
	};
}

interface ISetIDCategory {
	type: CreateSubCategoryActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: Nullable<string>;
	};
}

interface ISetIDsOfRestaurantsWhereToHide {
	type: CreateSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE;
	payload: {
		IDsOfRestaurantsWhereToHide: string[];
	};
}

interface ISetIDsOfRestaurantsAvailableForRepetition {
	type: CreateSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION;
	payload: {
		IDsOfRestaurantsAvailableForRepetition: string[];
	};
}

interface IChangeActivationSchedule {
	type: CreateSubCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: string;
	};
}

interface IChangeDeactivationSchedule {
	type: CreateSubCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: string;
	};
}

interface ISetFetchedTranslation {
	type: CreateSubCategoryActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: IMenuTranslation[];
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: CreateSubCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: CreateSubCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: CreateSubCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateSubCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateSubCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: CreateSubCategoryActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<ICreateSubCategoryValidationError> | null;
	};
}

interface IResetSelectedControls {
	type: CreateSubCategoryActionTypes.RESET_FIELDS;
}

export type TCreateSubCategoryAction =
	| IChangeVisibleForm
	| ISetFileId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IChangeNameOfSubCategory
	| ISetFetchedCategories
	| ISetIDCategory
	| ISetIDsOfRestaurantsWhereToHide
	| ISetIDsOfRestaurantsAvailableForRepetition
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
